import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import UiStore from 'lib/UiStore'
import api from 'lib/Api'

dayjs.extend(utc)

export const addPXSuffix = string => {
  if (!string) return ''
  if (isNaN(string)) return string //if string is not a number
  return `${string}px`
}

export const addImportant = string => `${string} !important`

export const noop = () => {}

export const getDateWithTimezone = () => {
  return dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
}

export const toCamelCaseKeys = obj => {
  const result = {}

  Object.keys(obj).forEach(key => {
    const camelKey = key.includes('_') ? key.replace(/_([a-z])/g, (_, char) => char.toUpperCase()) : key

    result[camelKey] = obj[key]
  })

  return result
}

export const saveAuditLogs = ({ action, newValues, previousValues, configType }) => {
  api.post('/api/v1/audit_logs', {
    new_values: newValues ? JSON.stringify(newValues) : null,
    previous_values: previousValues ? JSON.stringify(previousValues) : null,
    config_type: configType,
    action,
    created_at: getDateWithTimezone(),
    created_by: UiStore.tenant.name || '',
    '@timestamp': getDateWithTimezone(),
    version: 1,
  })
}
